import { Link } from 'wouter'
import { HugeiconsIcon } from '@hugeicons/react'
import { Trans } from '@lingui/react/macro'

import {
  ArrowRight02Icon,
  SmartPhone01Icon
} from '@hugeicons/core-solid-rounded'

import logo from '@/assets/logo.svg'
import { Sidebar, useIsOpen } from '@/features/sidebar'
import { StateBanner, useOrganization } from '@/features/organization'

const NavHeader: React.FC = function () {
  const { appUrl } = useOrganization()
  const [, toggleOpen] = useIsOpen()

  return (
    <div className="flex h-top-navbar w-full flex-row items-center justify-between gap-2.5 p-4">
      <div className="flex flex-row items-center gap-2.5">
        <button
          tabIndex={0}
          className="md:hidden size-8 text-text"
          onClick={toggleOpen}
        >
          <HugeiconsIcon icon={ArrowRight02Icon} className="size-full" />
        </button>
        <div className="flex-row items-center gap-1 hidden md:flex">
          <img className="size-7" alt="GuestGoodie Logo" src={logo} />
          <Link href="/" className="text-text font-lora font-semibold">
            GuestGoodie
          </Link>
        </div>
      </div>
      <div className="flex flex-row gap-2 items-center">
        <StateBanner />
        <a
          href={appUrl}
          className="relative flex flex-row items-center gap-2 rounded-small px-4 py-2 text-regular border-2 border-primary bg-transparent text-primary hover:bg-primary-bright disabled:border-primary-light disabled:hover:border-primary-light disabled:hover:bg-transparent focus:outline-secondary"
          target="_blank"
          rel="noreferrer"
        >
          <HugeiconsIcon icon={SmartPhone01Icon} className="size-6" />
          <span>
            <Trans>Open Guest-App</Trans>
          </span>
        </a>
      </div>
    </div>
  )
}

const Page: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex h-screen w-screen flex-col" id="PageLayout">
      <NavHeader />
      <div className="relative flex h-main-content flex-row">
        <Sidebar />
        <div className="relative size-full shrink grow pl-4 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  )
}

export default Page
